/* eslint-disable no-unused-vars */
import { Grid } from "@mui/material";

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { StringUtils } from "../../../../utils/StringUtils";

export default function PurchaseRequestDraftSummary(props) {
  const { t } = useTranslation();
  const translate = t;
  const [totalQuantity, setQuantity] = useState(0);

  useEffect(() => {
    if (props.purchaseItems != null) populateSummary(props.purchaseItems);
  }, [props.purchaseItems]);

  function calculateInvoiceAmount() {
    if (
      props.selectedDiscountType &&
      props.subTotalDiscount &&
      parseFloat(props.subTotalDiscount) > 0
    ) {
      if (props.selectedDiscountType.id == 1) {
        /*After Tax*/
        props.setInvoiceAmount(
          StringUtils.formattedNumber(
            (props.totalWithTax
              ? StringUtils.formattedNumber(
                  props.totalWithTax,
                  props.context.store.currencyDecimal
                )
              : 0) -
              (props.subTotalDiscount ? parseFloat(props.subTotalDiscount) : 0)
          )
        );
      } else {
        /*Before Tax*/
        let amountAfterDiscount = StringUtils.formattedNumber(
          (props.totalWithoutTax
            ? StringUtils.formattedNumber(
                props.totalWithoutTax,
                props.context.store.currencyDecimal
              )
            : 0) -
            (props.subTotalDiscount ? parseFloat(props.subTotalDiscount) : 0)
        );
        let taxAmount = 0;
        let taxPercentage = 0;
        if (props.purchaseItems && props.purchaseItems.length > 0) {
          taxPercentage = props.purchaseItems[0][6].v;
        }
        if (
          amountAfterDiscount &&
          StringUtils.formattedNumber(
            amountAfterDiscount,
            props.context.store.currencyDecimal
          ) > 0
        ) {
          taxAmount =
            (StringUtils.formattedNumber(
              amountAfterDiscount,
              props.context.store.currencyDecimal
            ) *
              StringUtils.formattedNumber(
                taxPercentage,
                props.context.store.currencyDecimal
              )) /
            100;
        }
        let finalAmount = parseFloat(amountAfterDiscount) + taxAmount;
        props.setInvoiceAmount(
          StringUtils.formattedNumber(
            finalAmount,
            props.context.store.currencyDecimal
          )
        );
      }
    } else {
      props.setInvoiceAmount(
        StringUtils.formattedNumber(
          props.totalWithTax
            ? StringUtils.formattedNumber(
                props.totalWithTax,
                props.context.store.currencyDecimal
              )
            : 0,
          props.context.store.currencyDecimal
        )
      );
    }
  }

  function populateSummary(purchaseItems) {
    let qty = 0;
    let tax = 0;
    let costWithoutTax = 0;
    let netCost = 0;

    purchaseItems.map((value) => {
      qty += parseFloat(value[3].v ? value[3].v : 0);
      tax += parseFloat(value[7].v ? value[7].v : 0);
      costWithoutTax += parseFloat(value[8].v ? value[8].v : 0);
      netCost += parseFloat(value[9].v ? value[9].v : 0);
    });
    setQuantity(
      StringUtils.formattedNumberWithStoreDecimal(qty, props.context)
    );
    props.setTax(
      StringUtils.formattedNumberWithStoreDecimal(tax, props.context)
    );
    props.setWithoutTax(
      StringUtils.formattedNumberWithStoreDecimal(costWithoutTax, props.context)
    );
    props.setWithTax(
      StringUtils.formattedNumberWithStoreDecimal(netCost, props.context)
    );

    if (!purchaseItems || purchaseItems.length == 0) {
      props.setInvoiceAmount(
        StringUtils.formattedNumberWithStoreDecimal(0, props.context)
      );
      props.setSubTotalDiscount(
        StringUtils.formattedNumberWithStoreDecimal(0, props.context)
      );
    }
  }

  return (
    <div>
      <hr />
      <b>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={3}>
            <table width="100%">
              <tbody>
                <tr>
                  <td>{translate("Toatl Quantity")}</td>
                  <td>{totalQuantity}</td>
                </tr>
              </tbody>
            </table>
          </Grid>
          <Grid item xs={12} sm={3}>
            <table width="100%">
              <tbody>
                <tr>
                  <td>{translate("Toatl W/O Tax")}</td>
                  <td>{props.totalWithoutTax}</td>
                </tr>
              </tbody>
            </table>
          </Grid>
          <Grid item xs={12} sm={3}>
            <table width="100%">
              <tbody>
                <tr>
                  <td>{translate("Toatl Tax")}</td>
                  <td>{props.totalTax}</td>
                </tr>
              </tbody>
            </table>
          </Grid>
          <Grid item xs={12} sm={3}>
            <table width="100%">
              <tbody>
                <tr>
                  <td>{translate("Toatl With Tax")}</td>
                  <td>{props.totalWithTax}</td>
                </tr>
              </tbody>
            </table>
          </Grid>
        </Grid>
      </b>
    </div>
  );
}
